import React from "react";
import "./Game_play_slider.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Game_play_card from "./Game_play_card/Game_play_card";
import { useNavigate } from "react-router-dom";

function Game_play_slider() {
      const navigate = useNavigate();
  return (
    <>
      <section className="Game_play_slider">
        <Swiper
          modules={[
            // Pagination,
            Autoplay,
          ]}
          spaceBetween={10}
          slidesPerView={2}
          //   pagination={{ clickable: true }}
        //   autoplay={{ delay: 3000 }}
          loop={true}
          className="Game_play_slider_swiper common_swiper"
        >
          <SwiperSlide>
            <Game_play_card imgSrc="/assets/images/home/game_play_cards/play_now_game.png"  onClick={() => navigate("/play-now-game")}/>
          </SwiperSlide>

          <SwiperSlide>
            <Game_play_card imgSrc="/assets/images/home/game_play_cards/lounching_soon.png" />
          </SwiperSlide>
 
        </Swiper>
      </section>
    </>
  );
}

export default Game_play_slider;
